import { defineRecipe } from "@chakra-ui/react"

export const iconRecipe = defineRecipe({
  base: {
    color: "currentcolor",
    display: "inline-block",
    flexShrink: "0",
    height: "var(--icon-size)",
    lineHeight: "1em",
    verticalAlign: "middle",
    width: "var(--icon-size)",
  },
  className: "chakra-icon",
  defaultVariants: {
    size: "inherit",
  },
  variants: {
    size: {
      sm: {
        "--icon-size": "sizes.4",
      },
      md: {
        "--icon-size": "sizes.5",
      },
      lg: {
        "--icon-size": "sizes.6",
      },
      xl: {
        "--icon-size": "sizes.7",
      },
      "2xl": {
        "--icon-size": "sizes.8",
      },
      inherit: {
        "--icon-size": "1em",
      },
      xs: {
        "--icon-size": "sizes.3",
      },
    },
  },
})
